export default __webpack_public_path__ + "static/media/exit.eb201833.svg";